const UnlinkSuite = () =>
  <>
    Are you sure you want to unlink this suite?<br /><br />
    Unlinking will result in a cascade removal of all tests using this suite, which in turn could invalidate all places where that suite is then used.<br /><br />
    This action cannot be undone.
  </>

export default UnlinkSuite
